import { render, staticRenderFns } from "./PatientMessages.vue?vue&type=template&id=067c8203&scoped=true&"
import script from "./PatientMessages.vue?vue&type=script&lang=ts&"
export * from "./PatientMessages.vue?vue&type=script&lang=ts&"
import style0 from "./PatientMessages.vue?vue&type=style&index=0&id=067c8203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c8203",
  null
  
)

export default component.exports